/**
 * Vertex shader (segitiga layar penuh), dipakai bersama oleh semua jenis shader.
 *
 * Ditulis sebagai string TS, bukan berkas `.glsl?raw`: impor `?raw` hanya
 * dipahami Vite (dev), sedangkan build produksi memakai `bun build` yang
 * gagal meresolvenya. Isi string di bawah harus tetap GLSL apa adanya
 * (`#version` harus di awal string, tanpa baris kosong di depan).
 */
export const LIQUID_GLASS_VERT = `#version 300 es
// Satu segitiga penuh-viewport, tanpa VBO — posisi dari gl_VertexID. Teknik
// standar untuk fullscreen shader; tidak butuh buffer atribut sama sekali.
void main() {
  vec2 pos[3] = vec2[3](vec2(-1.0, -1.0), vec2(3.0, -1.0), vec2(-1.0, 3.0));
  gl_Position = vec4(pos[gl_VertexID], 0.0, 1.0);
}
`;
